<template>

  <v-container fluid class="px-0 order-info-tracking-history">

    <!-- Order Tracking History -->
    <order-tracking-history class="pl-10 page-content" :order="order" />

  </v-container>

</template>

<script>
import OrderTrackingHistory from '@/components/orders/OrderTrackingHistory'

export default {
  name: 'OrderInfoTrackingHistory',

  components: {
    OrderTrackingHistory
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
    }
  },

  computed: {
    order () {
      return this.$parent.order
    }
  },

  methods: {
  }
}
</script>

<style>
</style>
